// noinspection JSUnusedGlobalSymbols

export class Config {
    public static readonly GOOGLE_MAPS_KEY: string = "preference/afj.fedelta.google.mapsKey";
    public static readonly GOOGLE_ANALYTICS_NON_PROD_KEY: string = "preference/afj.fedelta.google.analyticsNonProdKey";
    public static readonly GOOGLE_ANALYTICS_PROD_KEY: string = "preference/afj.fedelta.google.analyticsProdKey";
    public static readonly GOOGLE_ANALYTICS_SERVICE_APP_PROD_KEY: string = "preference/afj.fedelta.google.analyticsServiceAppProdKey";
    public static readonly GOOGLE_ANALYTICS_NON_PROD_API_SECRET: string = "preference/afj.fedelta.google.analyticsNonProdApiSecret";
    public static readonly GOOGLE_ANALYTICS_PROD_API_SECRET: string = "preference/afj.fedelta.google.analyticsProdApiSecret";
    public static readonly GOOGLE_ANALYTICS_SERVICE_APP_PROD_API_SECRET: string = "preference/afj.fedelta.google.analyticsServiceAppProdApiSecret";
}

export class Local {
    public static readonly APP_ID: string = "local/appId";
    public static readonly APP_NAME: string = "local/appName";
    public static readonly DATASERVER_URL: string = "local/dataserverURL";
    public static readonly LOGIN_TOKEN: string = "local/loginToken";
    public static readonly DEMO: string = "local/demo";
}
